import {
    dehydrate,
    type DehydratedState,
    hydrate,
    QueryClient,
    VueQueryPlugin,
    type VueQueryPluginOptions
} from "@tanstack/vue-query";
import {get, set} from 'idb-keyval';
import {MS_SECOND} from "~/constants/time";

export const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 1000 } },
})

export default defineNuxtPlugin((nuxt) => {
    const options: VueQueryPluginOptions = { queryClient }

    nuxt.vueApp.use(VueQueryPlugin, options)

    // Hydrate from IndexedDB
    nuxt.hooks.hook("app:created", async () => {
        try {
            const savedState = await get<DehydratedState>('vue-query')
            if (savedState) {
                hydrate(queryClient, savedState)
            }
        } catch (error) {
            console.error("Failed to hydrate Vue Query cache from IndexedDB", error)
        }

        // Auto-persist by interval
        const interval = setInterval(async () => {
            try {
                const dehydratedState = dehydrate(queryClient)
                await set('vue-query', dehydratedState)
                console.log('Query state has been persisted')
            } catch (error) {
                console.error("Failed to auto-persist Vue Query cache to IndexedDB", error)
            }
        }, 30 * MS_SECOND)

        window.addEventListener("beforeunload", () => {
            clearInterval(interval)
        })
    })

    // Persist to IndexedDB before window unload
    window.addEventListener("beforeunload", async () => {
        try {
            const dehydratedState = dehydrate(queryClient)
            await set('vue-query', dehydratedState)
        } catch (error) {
            console.error("Failed to persist Vue Query cache to IndexedDB", error)
        }
    })
})
